import React from 'react'
import { Box, Heading, Paragraph, Image, Text } from 'grommet'
import Adthrive from '../Adthrive'
import styled, { css } from 'styled-components'
import { useWindowSize } from '../../hook/useWindowSize'
import { usePersistValue } from '../../hook/usePersistValue'
import { replaceCDN } from '../../utils'
import { useSelector } from 'react-redux'
import { AbsoluteBox } from '../Common'

// import { rgba } from 'polished'

const TitleAdsBoxFullScreenStyle = css`
  width: 100%;
  max-width: 100%;
  margin: 0rem;
  background-color: ${props => props.bgColor};
  & div:last-child {
    margin-right: 2rem;
  }
  &::before {
    content: ''; // ::before and ::after both require content
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: ${props => props.theme.global.colors.toolTranslucentBg};
  }

  @media (max-width: 1152px) {
    & div:last-child {
      margin-right: 0rem;
    }
  }
`

const TitleAdsBoxNormalStyle = css`
  max-width: 140rem;
  width: calc(100% - 7rem);
  margin: 0 3.5rem;
  background-color: ${props => props.theme.global.colors.toolTranslucentBg};
`

const TitleAdsBox = styled(Box)`
  position: relative;
  align-self: center;
  justify-content: space-between;
  ${props =>
    props.fullScreenActive
      ? TitleAdsBoxFullScreenStyle
      : TitleAdsBoxNormalStyle}

  @media (max-width: 1152px) {
    flex-wrap: wrap;
    justify-content: center;
  }
  @media (max-width: 900px) {
    width: calc(100% - 2rem);
    margin: 0 1rem;
  }
`

const TitleParagraphBox = styled(Box)`
  /* flex-direction: row; */
  /* padding: 0 0 0 2rem; */
  position: relative;
  flex: 0 0 39rem;
  margin: 0 2rem;
  align-items: flex-start;
  align-self: stretch;

  @media (max-width: 1152px) {
    align-items: center;
    /* width: 100rem; */
    padding: 0.5rem 0rem 0rem;
    margin: 0 1rem;
    min-height: 7rem;
  }
  z-index: 1;
`

const AbsoluteCustomTitleBox = styled(AbsoluteBox)`
  min-width: 0;
  top: 3.1rem;
  left: 0rem;
  @media (max-width: 1152px) {
    transform: translateX(-50%);
    left: 50%;
    top: 2.6rem;
  }
`

const AbsoluteTitleBox = styled(AbsoluteBox)`
  min-width: 0;
  top: ${props => (!props.titleActive ? '50%' : '0')};
  left: ${props => (!props.titleActive ? '0' : '-2rem')};
  transform: ${props => (!props.titleActive ? 'translateY(-50%)' : 'unset')};
  padding: ${props => (!props.titleActive ? '0' : '.3rem 1rem')};
  background-color: ${props =>
    !props.titleActive ? 'transparent' : props.bgColor};
  @media (max-width: 1152px) {
    transform: ${props =>
      !props.titleActive ? 'translate(-50%, -50%)' : 'translateX(-50%)'};
    left: 50%;
  }
`

const PageHeaderBox = styled(Adthrive)`
  min-height: 100px;
  /* width: 97rem; */
  flex: 0 1 97rem;
  z-index: 1;
  & > div {
    margin-top: 0px;
    margin-bottom: 0px;
  }

  @media (max-width: 550px) {
    min-height: 110px;
  }
`

const Title = styled(Heading)`
  /* align-self: center; */
  text-align: start;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  line-height: 1.1;
  font-size: ${props =>
    !props.titleActive ? props.titleStyles.fontSize.desktop : '1.6rem'};
  letter-spacing: ${props => props.titleStyles.letterSpacing};
  color: ${props =>
    !props.titleActive
      ? props.theme.global.colors.text
      : props.theme.global.colors.white};
  @media (max-width: 1152px) {
    text-align: center;
  }
  @media (max-width: 550px) {
    font-size: ${props =>
      !props.titleActive ? props.titleStyles.fontSize.mobile : '1.6rem'};
  }
`

const CustomTitle = styled(Text)`
  /* align-self: center; */
  font-size: 2.9rem;
  line-height: 1.1;
  text-align: start;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  font-weight: 600;
  /* color: white; */
  @media (max-width: 1152px) {
    text-align: center;
  }
  @media (max-width: 550px) {
    font-size: 2.7rem;
  }
`

const ParagraphTitle = styled(Paragraph)`
  line-height: 1.2;
  margin-bottom: 0px;
  text-align: start;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  /* color: white; */
  @media (max-width: 1152px) {
    text-align: center;
  }
  /* align-self: center; */
  @media (max-width: 550px) {
    font-size: 1.8rem;
  }
`

const PageTitle = ({
  page,
  title,
  caption,
  fullScreenActive,
  bgColor,
  titleStyles = {
    letterSpacing: 'normal',
    fontSize: { desktop: '2.9rem', mobile: '2.7rem' },
  },
  isFixedWheelColors = false,
}) => {
  // const { isPremium: showBannerBox } = useIsPremium()
  // const {
  //   text: titlePersist,
  //   active: titleActivePersist,
  //   description: descriptionPersist,
  // } = useSelector(state => state[page].title)
  const {
    value: {
      text: titlePersist,
      active: titleActivePersist,
      description: descriptionPersist,
    },
  } = usePersistValue(state => state[page].title, {
    active: false,
    text: '',
    description: '',
    popup: '',
  })
  const banners = useSelector(state => state.settings.banners)
  const { value: toolColors } = usePersistValue(
    state => state.settings.wheelColors.colors,
    ['', '', '', ''],
  )
  const windowSize = useWindowSize()

  let banner = null
  let bannerSrc = ''
  // if (showBannerBox) {
  if (banners.on) {
    if (banners.topDesktop || banners.topMobile) {
      if (windowSize.width > 1152) {
        banner = banners.topDesktop
      } else {
        //mobile view
        banner = banners.topMobile
      }
      bannerSrc = replaceCDN(banner?.src)
    }
  }

  let titleShown = title
  let descriptionShown = caption
  if (titleActivePersist) {
    titleShown = titlePersist
    descriptionShown = descriptionPersist
  }

  return (
    <TitleAdsBox
      direction="row"
      bgColor={bgColor}
      // background={true ? '#B1BDA8' : `${rgba(`#fff`, 0.15)}`}
      // round={{ size: '2rem', corner: 'top' }}
      align="center"
      // wrap={true}
      fullScreenActive={fullScreenActive}
    >
      <TitleParagraphBox>
        <AbsoluteTitleBox
          bgColor={isFixedWheelColors ? '#2b580c' : toolColors[0]}
          titleActive={titleActivePersist}
        >
          <Title
            level={2}
            margin="0"
            titleActive={titleActivePersist}
            titleStyles={titleStyles}
          >
            {title}
          </Title>
          {!titleActivePersist && (
            <ParagraphTitle margin={{ horizontal: '0rem' }}>
              {caption}
            </ParagraphTitle>
          )}
        </AbsoluteTitleBox>
        {titleActivePersist && (
          <AbsoluteCustomTitleBox>
            <CustomTitle margin="0">{titleShown}</CustomTitle>
            <ParagraphTitle margin={{ horizontal: '0rem' }}>
              {descriptionShown}
            </ParagraphTitle>
          </AbsoluteCustomTitleBox>
        )}
      </TitleParagraphBox>
      <PageHeaderBox
        id="pageHeader"
        justify="center"
        align={!banner ? 'stretch' : banner.alignment}
        fullScreenActive={fullScreenActive}
        // background="#aaa"
        // flex="shrink"
      >
        {banner && <Image src={bannerSrc} />}
      </PageHeaderBox>
    </TitleAdsBox>
  )
}

export default PageTitle
